import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import PortalBalanceCard from "../components/portal/PortalBalanceCard";
import PortalContractAcceptanceCard from "../components/portal/PortalContractAcceptanceCard";
import PortalMandateCard from "../components/portal/PortalMandateCard";
import PortalPageHeading from "../components/portal/PortalPageHeading";
import PortalPaymentsList from "../components/portal/PortalPaymentsList";
import { usePortalPage } from "../features/portal/hooks/usePortalPage";
import { selectPortalBalance } from "../features/portal/portal-slice";
import { fetchPortalBalance } from "../features/portal/slice-extensions/portal-slice-extension";

/** Money: the contract to accept, the contracts, every payment with its action and document, and direct debit. */
const PortalMoneyPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { session, memberId, members, selectMember } = usePortalPage();
  const balance = useAppSelector(selectPortalBalance(memberId ?? ""));

  useEffect(() => {
    if (memberId) dispatch(fetchPortalBalance(memberId));
  }, [memberId, dispatch]);

  if (!session) return null;

  return (
    <section className="mx-auto w-full max-w-3xl px-4 py-8">
      <PortalPageHeading
        title={t("portal.money.title")}
        intro={t("portal.money.intro")}
        members={members}
        memberId={memberId}
        onSelectMember={selectMember}
      />
      {memberId && <PortalContractAcceptanceCard memberId={memberId} />}
      <PortalBalanceCard balance={balance} showRecentPayments={false} />
      {memberId && <PortalPaymentsList memberId={memberId} />}
      {memberId && <PortalMandateCard memberId={memberId} />}
    </section>
  );
};

export default PortalMoneyPage;
